import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fa97496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skill-edit" }
const _hoisted_2 = { class: "skill" }
const _hoisted_3 = { class: "skill__level" }
const _hoisted_4 = { class: "skill__name" }
const _hoisted_5 = { class: "skill__experience" }
const _hoisted_6 = ["max"]
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.tmpSkill.level) + " ", 1),
        _createElementVNode("button", {
          class: "skill-edit__level-up",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.levelUp && _ctx.levelUp(...args)))
        }, [
          _createVNode(_component_Icon, { name: "ArrowIcon" })
        ]),
        _createElementVNode("button", {
          class: "skill-edit__level-down",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.levelDown && _ctx.levelDown(...args)))
        }, [
          _createVNode(_component_Icon, { name: "ArrowIcon" })
        ])
      ]),
      _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t(`skill__${_ctx.tmpSkill.name}`)), 1),
      _createElementVNode("span", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tmpSkill.experience) = $event)),
          class: "skill-edit__experience",
          min: "0",
          max: _ctx.cup,
          inputmode: "number",
          type: "number"
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.tmpSkill.experience]
        ]),
        _createTextVNode(" / " + _toDisplayString(_ctx.cup), 1)
      ]),
      _createElementVNode("progress", {
        class: "skill__progress",
        max: "100",
        value: _ctx.experiencePercent,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.experienceUpdate && _ctx.experienceUpdate(...args)))
      }, _toDisplayString(_ctx.experiencePercent.toFixed()) + "% ", 9, _hoisted_7)
    ]),
    _createElementVNode("nav", null, [
      _createVNode(_component_Button, {
        secondary: "",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ui-remove")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        secondary: "",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ui-cancel")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, { onClick: _ctx.save }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ui-save")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}